
export const apiUrls = {
  resumeUpload: `https://asr.iitm.ac.in/demo/upload`,
};
